import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    categories: [],
    skillsNames: [],
    specialities: [],
  },
  emptySkillIndex: null,
};

const skillSlice = createSlice({
  name: "skill",
  initialState,
  reducers: {
    updateSkillData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    resetSkillData: (state) => {
      state.data = { ...initialState, categories: state.data.categories };
    },
    setEmptySkillIndex: (state, action) => {
      state.emptySkillIndex = action.payload;
    },
  },
});

export const { updateSkillData, resetSkillData, setEmptySkillIndex } =
  skillSlice.actions;
export default skillSlice.reducer;
